import { Avatar, Box, Stack } from '@mui/material';
import { CommunityUser, JunoUser } from '@juno/client-api/model';

interface LittleHeadsProps {
  items: CommunityUser[] | number[];
  totalItems?: number;
}
export const LittleHeads: React.FC<LittleHeadsProps> = ({ items, totalItems }) => {
  const maxAvatarsToShow = 5;

  if (items.length === 0 && totalItems === 0) {
    return (
      <Box
        sx={{
          width: 22,
          height: 22,
          borderRadius: '50%',
          bgcolor: 'white',
          border: '1px solid black',
          color: 'black',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: 12,
          zIndex: items.length + 2,
        }}
      >
        0
      </Box>
    );
  }

  // Handle the case where items are numbers
  if (typeof items[0] === 'number') {
    return (
      <Stack direction='row' spacing={-1} alignItems='center'>
        {(items as number[]).slice(0, maxAvatarsToShow).map((num, index) => (
          <Box
            key={index}
            sx={{
              width: 22,
              height: 22,
              borderRadius: '50%',
              bgcolor: num > 0 ? (theme) => theme.palette.primary.main : 'white',
              border: num > 0 ? '2px solid transparent' : '1px solid black',
              color: num > 0 ? 'white' : 'black',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: 12,
            }}
          >
            {num}
          </Box>
        ))}
        {items.length > maxAvatarsToShow && (
          <Box
            sx={{
              width: 22,
              height: 22,
              borderRadius: '50%',
              bgcolor: (theme) => theme.palette.primary.main,
              border: '2px solid white',
              color: 'white',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: 12,
            }}
          >
            +{items.length - maxAvatarsToShow}
          </Box>
        )}
      </Stack>
    );
  }

  // Handle the case where items are JunoUser[]
  const displayedItems = (items as JunoUser[]).slice(0, maxAvatarsToShow);

  // the differences in width/height are to account for the 2px white border on avatars
  return (
    <Stack direction='row' spacing={'-14px'} alignItems='center'>
      {displayedItems.map((item, index) => (
        <Avatar
          key={index}
          src={item.icon || item.avatar || ''}
          alt={`${item.first_name} ${item.last_name}`}
          sx={{
            width: 26,
            height: 26,
            border: '2px solid white',
            zIndex: items.length + index,
          }}
        />
      ))}
      {totalItems && (
        <Box
          sx={{
            width: 26,
            height: 26,
            borderRadius: '50%',
            bgcolor: (theme) => theme.palette.primary.main,
            border: '2px solid white',
            color: 'white',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: 12,
            zIndex: items.length + 2,
          }}
        >
          {totalItems}
        </Box>
      )}
    </Stack>
  );
};
export default LittleHeads;
